module.exports = __webpack_public_path__ + "src/resources/Images/Illustration - Error500.png";